<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("commons.notification") }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <v-text-field
            v-model="notification.notification_object"
            :rules="rules.notification_object"
            :label="$t('commons.object')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-select
            v-model="notification.users"
            :items="users"
            :rules="rules.users"
            item-text="email"
            item-value="id"
            :label="$t('commons.send_to')"
            multiple
            chips
            attach
            outlined
          ></v-select>

          <!-- <v-textarea
            v-model="notification.description"
            :rules="rules.description"
            :label="$t('commons.message')"
            outlined
            dense
          ></v-textarea> -->
          <div style="margin-bottom: 25px">
            <label>{{ $t("commons.message") }}</label>
            <ckeditor
              :editor="editor"
              :disabled="!isEditable"
              tag-name="textarea"
              rows="5"
              v-model="notification.description"
              :config="editorConfig"
              :hint="$t('views.template.hint.description')"
              :label="$t('commons.message')"
              className="content-element"
            ></ckeditor>
          </div>

          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              @click="save"
              :disabled="!isEditable"
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { InternalNotificationService, TeamService } from "@/services"
import { isEqual } from "@/utils/object"
import { required, max64 } from "@/utils/validator"

import _ from "lodash"

export default {
  name: "NotificationEditor",
  props: {
    hasUniqueName: {
      type: Function,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    }
  },
  computed: {
    notification: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    },
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  data() {
    return {
      rules: {
        description: [required],
        users: [required],
        notification_object: [required, max64]
      },
      users: [],
      // selectedUsers: [],
      nameField: null,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "paragraph",
          "heading1",
          "heading2",
          "bold",
          "italic",
          "|",
          "link",
          "|",
          "undo",
          "redo",
          "-",
          "numberedList",
          "bulletedList"
        ]
        // The configuration of the editor.
      }
    }
  },
  created() {
    this.fetchFieldTypes()
  },
  methods: {
    fetchFieldTypes() {
      TeamService.getTeam(this, this.projectId).then(response => {
        this.users = response
      })
    },
    // initializeSelectedUsers() {
    //   this.selectedUsers = this.notification.users || []
    // },
    getDefaultValue() {
      return {
        notification_object: "",
        description: "",
        users: []
      }
    },
    cancel() {
      this.$emit("cancel")
    },
    async performSave(data) {
      if (data.id > 0) {
        return InternalNotificationService.put(data)
      } else {
        return InternalNotificationService.post(this.projectId, data)
      }
    },
    async save() {
      // alert(this.notification.users)
      this.notification.project = this.projectId
      // this.notification.users = this.selectedUsers

      if (this.$refs.form.validate()) {
        if (isEqual(this.notification, this.value)) {
          this.$emit("success")
        } else {
          this.performSave(this.notification)
            .then(response => {
              this.$emit("input", response)
              this.$emit("success")
            })
            .catch(error => {
              const message = error?.response.data?.state
              this.$emit("error", message)
            })
        }
      }
    }
  }
}
</script>
<style>
.ck.ck-editor__main > .ck-editor__editable {
  height: 200px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
